// @ts-nocheck
import React from 'react';
import { ApplyPluginsType } from '/app/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "path": "/customer/smsPay/LS/result",
    "component": require('@/layouts/index').default,
    "routes": [
      {
        "path": "/customer/smsPay/LS/result",
        "component": require('@/pages/customer/smsPay/LS/result').default,
        "exact": true
      }
    ]
  },
  {
    "path": "/customer/smsPay/LS/pay",
    "component": require('@/layouts/index').default,
    "routes": [
      {
        "path": "/customer/smsPay/LS/pay",
        "component": require('@/pages/customer/smsPay/LS/pay').default,
        "exact": true
      }
    ]
  },
  {
    "path": "/equity",
    "name": "权益",
    "microApp": "equity",
    "microAppProps": {
      "autoCaptureError": true,
      "autoSetLoading": true,
      "className": "myContainer",
      "wrapperClassName": "micro-equity-wrapper"
    },
    "exact": false,
    "component": (() => {
          const { getMicroAppRouteComponent } = umiExports;
          return getMicroAppRouteComponent({ appName: 'equity', base: '/', masterHistoryType: 'hash', routeProps: {'settings':{},'autoCaptureError':true,'autoSetLoading':true,'className':'myContainer','wrapperClassName':'micro-equity-wrapper'} })
        })()
  },
  {
    "path": "/verification",
    "name": "核销—消费详情-网点",
    "microApp": "verification",
    "microAppProps": {
      "autoCaptureError": true,
      "autoSetLoading": true,
      "className": "myContainer",
      "wrapperClassName": "micro-verification-wrapper"
    },
    "exact": false,
    "component": (() => {
          const { getMicroAppRouteComponent } = umiExports;
          return getMicroAppRouteComponent({ appName: 'verification', base: '/', masterHistoryType: 'hash', routeProps: {'settings':{},'autoCaptureError':true,'autoSetLoading':true,'className':'myContainer','wrapperClassName':'micro-verification-wrapper'} })
        })()
  },
  {
    "path": "/order",
    "name": "订单",
    "microApp": "order",
    "microAppProps": {
      "autoCaptureError": true,
      "autoSetLoading": true,
      "className": "myContainer",
      "wrapperClassName": "micro-order-wrapper"
    },
    "exact": false,
    "component": (() => {
          const { getMicroAppRouteComponent } = umiExports;
          return getMicroAppRouteComponent({ appName: 'order', base: '/', masterHistoryType: 'hash', routeProps: {'settings':{},'autoCaptureError':true,'autoSetLoading':true,'className':'myContainer','wrapperClassName':'micro-order-wrapper'} })
        })()
  },
  {
    "path": "/goods",
    "name": "商品模板",
    "microApp": "goods",
    "microAppProps": {
      "autoCaptureError": true,
      "autoSetLoading": true,
      "className": "myContainer",
      "wrapperClassName": "micro-goods-wrapper"
    },
    "exact": false,
    "component": (() => {
          const { getMicroAppRouteComponent } = umiExports;
          return getMicroAppRouteComponent({ appName: 'goods', base: '/', masterHistoryType: 'hash', routeProps: {'settings':{},'autoCaptureError':true,'autoSetLoading':true,'className':'myContainer','wrapperClassName':'micro-goods-wrapper'} })
        })()
  },
  {
    "path": "/vvip",
    "name": "vvip",
    "microApp": "vvip",
    "microAppProps": {
      "autoCaptureError": true,
      "autoSetLoading": true,
      "className": "myContainer",
      "wrapperClassName": "micro-vvip-wrapper"
    },
    "exact": false,
    "component": (() => {
          const { getMicroAppRouteComponent } = umiExports;
          return getMicroAppRouteComponent({ appName: 'vvip', base: '/', masterHistoryType: 'hash', routeProps: {'settings':{},'autoCaptureError':true,'autoSetLoading':true,'className':'myContainer','wrapperClassName':'micro-vvip-wrapper'} })
        })()
  },
  {
    "path": "/limousine",
    "name": "limousine",
    "microApp": "limousine",
    "microAppProps": {
      "autoCaptureError": true,
      "autoSetLoading": true,
      "className": "myContainer",
      "wrapperClassName": "micro-limousine-wrapper"
    },
    "exact": false,
    "component": (() => {
          const { getMicroAppRouteComponent } = umiExports;
          return getMicroAppRouteComponent({ appName: 'limousine', base: '/', masterHistoryType: 'hash', routeProps: {'settings':{},'autoCaptureError':true,'autoSetLoading':true,'className':'myContainer','wrapperClassName':'micro-limousine-wrapper'} })
        })()
  },
  {
    "path": "/bocom",
    "name": "bocom",
    "microApp": "bocom",
    "microAppProps": {
      "autoCaptureError": true,
      "autoSetLoading": true,
      "className": "myContainer",
      "wrapperClassName": "micro-bocom-wrapper"
    },
    "exact": false,
    "component": (() => {
          const { getMicroAppRouteComponent } = umiExports;
          return getMicroAppRouteComponent({ appName: 'bocom', base: '/', masterHistoryType: 'hash', routeProps: {'settings':{},'autoCaptureError':true,'autoSetLoading':true,'className':'myContainer','wrapperClassName':'micro-bocom-wrapper'} })
        })()
  },
  {
    "path": "/promo",
    "name": "promo",
    "microApp": "promo",
    "microAppProps": {
      "autoCaptureError": true,
      "autoSetLoading": true,
      "className": "myContainer",
      "wrapperClassName": "micro-promo-wrapper"
    },
    "exact": false,
    "component": (() => {
          const { getMicroAppRouteComponent } = umiExports;
          return getMicroAppRouteComponent({ appName: 'promo', base: '/', masterHistoryType: 'hash', routeProps: {'settings':{},'autoCaptureError':true,'autoSetLoading':true,'className':'myContainer','wrapperClassName':'micro-promo-wrapper'} })
        })()
  },
  {
    "path": "/special",
    "name": "special",
    "microApp": "special",
    "microAppProps": {
      "autoCaptureError": true,
      "autoSetLoading": true,
      "className": "myContainer",
      "wrapperClassName": "micro-special-wrapper"
    },
    "exact": false,
    "component": (() => {
          const { getMicroAppRouteComponent } = umiExports;
          return getMicroAppRouteComponent({ appName: 'special', base: '/', masterHistoryType: 'hash', routeProps: {'settings':{},'autoCaptureError':true,'autoSetLoading':true,'className':'myContainer','wrapperClassName':'micro-special-wrapper'} })
        })()
  },
  {
    "path": "/trainmeal",
    "name": "trainmeal",
    "microApp": "trainmeal",
    "microAppProps": {
      "autoCaptureError": true,
      "autoSetLoading": true,
      "className": "myContainer",
      "wrapperClassName": "micro-trainmeal-wrapper"
    },
    "exact": false,
    "component": (() => {
          const { getMicroAppRouteComponent } = umiExports;
          return getMicroAppRouteComponent({ appName: 'trainmeal', base: '/', masterHistoryType: 'hash', routeProps: {'settings':{},'autoCaptureError':true,'autoSetLoading':true,'className':'myContainer','wrapperClassName':'micro-trainmeal-wrapper'} })
        })()
  },
  {
    "path": "/ticket",
    "name": "ticket",
    "microApp": "ticket",
    "microAppProps": {
      "autoCaptureError": true,
      "autoSetLoading": true,
      "className": "myContainer",
      "wrapperClassName": "micro-ticket-wrapper"
    },
    "exact": false,
    "component": (() => {
          const { getMicroAppRouteComponent } = umiExports;
          return getMicroAppRouteComponent({ appName: 'ticket', base: '/', masterHistoryType: 'hash', routeProps: {'settings':{},'autoCaptureError':true,'autoSetLoading':true,'className':'myContainer','wrapperClassName':'micro-ticket-wrapper'} })
        })()
  },
  {
    "path": "/dk",
    "name": "dk",
    "microApp": "dk",
    "microAppProps": {
      "autoCaptureError": true,
      "autoSetLoading": true,
      "className": "myContainer",
      "wrapperClassName": "micro-dk-wrapper"
    },
    "exact": false,
    "component": (() => {
          const { getMicroAppRouteComponent } = umiExports;
          return getMicroAppRouteComponent({ appName: 'dk', base: '/', masterHistoryType: 'hash', routeProps: {'settings':{},'autoCaptureError':true,'autoSetLoading':true,'className':'myContainer','wrapperClassName':'micro-dk-wrapper'} })
        })()
  },
  {
    "path": "/chatbot",
    "name": "chatbot",
    "microApp": "chatbot",
    "microAppProps": {
      "autoCaptureError": true,
      "autoSetLoading": true,
      "className": "myContainer",
      "wrapperClassName": "micro-chatbot-wrapper"
    },
    "exact": false,
    "component": (() => {
          const { getMicroAppRouteComponent } = umiExports;
          return getMicroAppRouteComponent({ appName: 'chatbot', base: '/', masterHistoryType: 'hash', routeProps: {'settings':{},'autoCaptureError':true,'autoSetLoading':true,'className':'myContainer','wrapperClassName':'micro-chatbot-wrapper'} })
        })()
  },
  {
    "path": "/",
    "component": require('@/layouts/index').default,
    "routes": [
      {
        "path": "/",
        "component": require('@/pages/index').default,
        "layout": "@/layouts/index",
        "exact": true
      },
      {
        "path": "/clear",
        "component": require('@/pages/clear').default,
        "exact": true
      },
      {
        "path": "/personal",
        "component": require('@/pages/personal').default,
        "exact": true
      },
      {
        "path": "/login",
        "component": require('@/pages/memberEquity/login').default,
        "exact": true
      },
      {
        "path": "/activate",
        "component": require('@/pages/activate').default,
        "exact": true
      },
      {
        "path": "/pay",
        "component": require('@/pages/pay').default,
        "exact": true
      },
      {
        "path": "/payCallback",
        "component": require('@/pages/payCallback').default,
        "exact": true
      },
      {
        "path": "/miniprogramPay",
        "component": require('@/pages/miniprogramPay').default,
        "exact": true
      },
      {
        "path": "/result",
        "component": require('@/pages/result').default,
        "exact": true
      },
      {
        "path": "/discountCouponList",
        "component": require('@/pages/discountCouponList').default,
        "exact": true
      },
      {
        "path": "/historyDiscountCouponList",
        "component": require('@/pages/historyDiscountCouponList').default,
        "exact": true
      },
      {
        "path": "/selectDiscount",
        "component": require('@/pages/selectDiscount').default,
        "exact": true
      },
      {
        "path": "/selectEquity",
        "component": require('@/pages/selectEquity').default,
        "exact": true
      },
      {
        "path": "/memberEquity/levelZone",
        "component": require('@/pages/memberEquity/levelZone').default,
        "exact": true
      },
      {
        "path": "/memberEquity/levelZone/equity",
        "component": require('@/pages/memberEquity/levelZone/equity').default,
        "exact": true
      },
      {
        "path": "/memberEquity/levelZone/equityGoods",
        "component": require('@/pages/memberEquity/levelZone/equityGoods').default,
        "exact": true
      },
      {
        "path": "/memberEquity/recommend",
        "component": require('@/pages/memberEquity/recommend').default,
        "exact": true
      },
      {
        "path": "/memberEquity/levelZone/product",
        "component": require('@/pages/memberEquity/levelZone/product').default,
        "exact": true
      },
      {
        "path": "/memberEquity/login",
        "component": require('@/pages/memberEquity/login').default,
        "exact": true
      },
      {
        "path": "/memberEquity/oauth",
        "component": require('@/pages/memberEquity/oauth').default,
        "exact": true
      },
      {
        "path": "/transfer",
        "component": require('@/pages/transfer').default,
        "exact": true
      },
      {
        "path": "/personalHF",
        "component": require('@/pages/personalHF').default,
        "exact": true
      },
      {
        "path": "/personalCenter",
        "component": require('@/pages/personalCenter').default,
        "exact": true
      },
      {
        "path": "/personalCenter/myPoint",
        "component": require('@/pages/personalCenter/myPoint').default,
        "exact": true
      },
      {
        "path": "/discountCouponGoodsList",
        "component": require('@/pages/discountCouponGoodsList').default,
        "exact": true
      },
      {
        "path": "/bridgeAuth",
        "component": require('@/pages/bridgeAuth').default,
        "exact": true
      },
      {
        "path": "/error/cookie",
        "component": require('@/pages/error/cookie').default,
        "exact": true
      },
      {
        "path": "/demo/storageError",
        "component": require('@/pages/demo/storageError').default,
        "exact": true
      },
      {
        "path": "/demo/dpTracker",
        "component": require('@/pages/demo/dpTracker').default,
        "exact": true
      },
      {
        "path": "/errorRenderTest",
        "component": require('@/pages/errorRenderTest').default,
        "exact": true
      },
      {
        "component": require('@/pages/404').default,
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
